'use strict';
import React, { PureComponent } from 'react';
import Formulario from './Formulario'
import Tabla from './Tabla'
import ModalIngresoAjustes from './ModalIngresoAjustes'
import ModalDatosCuenta from '../ModalDatosCuenta'

class IngresoAjustes extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            currentAccuntId: this.props.data.idEntidad
        }
    }


    componentDidMount() {
        /*el id que cambia es el idEntidad de panel seleccion*/
        // this.props.actions.getScreenData('CARGAAJUSTES', this.props.data.idEntidad);

        let { cuenta } = this.props;
        this.props.actions.getScreenDataIngresoAjustes('CARGAAJUSTES', cuenta.CuentaTarjetaId);
    }

    componentWillReceiveProps(nextProps) {

        let { cuenta } = this.props;
        if (this.state.currentAccuntId != nextProps.data.idEntidad) {
            this.setState({ currentAccuntId: nextProps.data.idEntidad });
            // this.props.actions.getScreenData('CARGAAJUSTES', nextProps.data.idEntidad);
            this.props.actions.getScreenDataIngresoAjustes('CARGAAJUSTES', cuenta.CuentaTarjetaId);

        }
    }

    componentWillUnmount() {
        this.props.actions.resetStateIngresoAjustes();
    }

    render() {
        let data = this.props.data;
        let { ingresoAjustes, denegar, seleccionarMotivo, cambiarImporteConIva, ajusteCargoRdButton, actions, cuenta  } = this.props;
        const ingresoAjuste = ingresoAjustes.data;
        const rowSeleccionada = ingresoAjuste.rowSeleccionada;
        const ajustes = ingresoAjuste.ajustes;
        const siNoConfirmacion = ingresoAjuste.siNoConfirmacion;
        const permisosUsuario = ingresoAjuste.permisos;
        const parametroGeneral = ingresoAjuste.parametroGeneral;

        let modalDatosCuenta = ingresoAjuste && ingresoAjuste.mostrarModalAjustes ? <ModalIngresoAjustes
                                                                limpiarForm={actions.limpiarForm}
                                                                openModalAjustesCargos={actions.openModalAjustesCargos}
                                                                titulo="Ajustes y Cargos Individuales"
                                                                mensaje={"¿Está seguro que desea cancelar la operación?"}
                                                                />
                                                            :
                                                                null;

        let modalConfirmacionAjusteCargo = ingresoAjuste && ingresoAjuste.mostrarModalInfo ? <ModalDatosCuenta
                                                                ocultarModal={actions.ocultarModalInfoAjustesCargos}
                                                                titulo="Ajustes y Cargos Individuales"
                                                                mensaje={ingresoAjuste.msjModalInfo}
                                                                />
                                                            :
                                                                null;

        let loading = ingresoAjuste.isLoading ? <div className="loading">Loading &#8230;</div> : null;

        let componente = <div>

            <Formulario cuenta={cuenta} actions={this.props.actions} parametroGeneral={parametroGeneral} ajusteCargoRdButton={ajusteCargoRdButton} ingresoAjuste={ingresoAjuste} seleccionarMotivo={seleccionarMotivo} cambiarImporteConIva={cambiarImporteConIva} />

            <Tabla ingresoAjuste={ingresoAjuste}
                expandirRow={actions.expandirRow}
                rowSeleccionada={rowSeleccionada}
                ajustes={ajustes}
                getCodigo={actions.getCodigo}
                confirmarAjuste={actions.confirmar}
                denegarAjuste={denegar}
                editar={actions.editar}
                eliminarAjuste={actions.eliminar}
                permisosUsuario={permisosUsuario}
                siNoConfirmacion={siNoConfirmacion}
            />
        </div>;

        return (
            <form id="" name="Formulario" className="" method="POST">
                <div className="">
                    <div className="container-fluid">
                        {modalConfirmacionAjusteCargo}
                        {modalDatosCuenta}
                        {loading}
                        {componente}
                    </div>
                </div>
            </form>
        );
    }
}
export default IngresoAjustes;